import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
// import { getContext } from 'recompose'

const propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  size: PropTypes.string,
  state: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  labelText: PropTypes.string,
  static: PropTypes.bool,
  addon: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.object,
}

const defaultProps = {
  tag: 'p',
  type: 'text',
}

class Input extends React.Component {
  render() {
    const {
      className,
      theme,
      type,
      size,
      state,
      tag,
      addon,
      static: staticInput,
      getRef,
      ...attributes
    } = this.props

    const checkInput = ['radio', 'checkbox'].indexOf(type) > -1

    const fileInput = type === 'file'
    const textareaInput = type === 'textarea'
    const selectInput = type === 'select'
    let Tag = selectInput || textareaInput ? type : 'input'

    let formControlClass = 'form-control'

    if (staticInput) {
      formControlClass = theme[`${formControlClass}-static`]
      Tag = tag
    } else if (fileInput) {
      formControlClass = theme[`${formControlClass}-file`]
    } else if (checkInput) {
      if (addon) {
        formControlClass = null
      } else {
        formControlClass = theme['form-check-input']
      }
    }

    const classes = classNames(
      className,
      state ? theme[`form-control-${state}`] : false,
      size ? theme[`form-control-${size}`] : false,
      formControlClass,
    )

    if (Tag === 'input') {
      attributes.type = type
    }

    return <Tag key="input" {...attributes} ref={getRef} className={classes} />
  }
}

Input.propTypes = propTypes
Input.defaultProps = defaultProps

// const withTheme = getContext({ theme: PropTypes.object })
// export default withTheme(Input)

export default Input



// WEBPACK FOOTER //
// ./ui/Input/Input.js